import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_PRESCHOOL_EDUCATION_PLANS } from '@/api/endpoints';
import { PRESCHOOL_EDUCATION_PLANS_QUERY_KEY } from '@/api/queryKeys';
import type {
  AchievableResult,
  PreschoolEducationPlan,
  TextWithAttachments,
} from '@/types/diary';
import { unwrapAxiosResponse } from '@/utils/axios';

interface PreschoolEducationPlanResponse {
  id: string;
  name: string;
  datePeriod: {
    from: string;
    to: string;
  };
  studentMessage?: string | null;
  content: TextWithAttachments;
  notes: TextWithAttachments;
  achievableValuesAndVirtues: string[];
  achievableResults: AchievableResult[];
  transversalSkills: AchievableResult[];
}

const toPreschoolEducationPlan = ({
  datePeriod,
  studentMessage,
  ...plan
}: PreschoolEducationPlanResponse): PreschoolEducationPlan => ({
  ...plan,
  dateFrom: datePeriod.from,
  dateTo: datePeriod.to,
  studentMessage: studentMessage ?? undefined,
});

export const usePreschoolEducationPlans = (): PreschoolEducationPlan[] => {
  const { data } = useQuery({
    queryKey: PRESCHOOL_EDUCATION_PLANS_QUERY_KEY,
    queryFn: () =>
      apiClient
        .get<PreschoolEducationPlanResponse[]>(API_PRESCHOOL_EDUCATION_PLANS)
        .then(unwrapAxiosResponse)
        .then((plans) => plans.map(toPreschoolEducationPlan)),
  });

  return data ?? [];
};
